import { useMutation } from '@gogame/query';

import { exportFinancialResults } from 'scenes/FinancialResults/sources/financialResults';

import { exportFR } from '../queryKeyFactory';

export const useExportFinancialResults = () => {
  const exportFRMutation = useMutation(exportFR(), exportFinancialResults);

  const handleAction = async params => {
    await exportFRMutation.mutateAsync(params);
  };

  return [handleAction, exportFRMutation];
};
